import { forwardRef } from 'react';
import type { IconButtonProps } from '@mui/material';
import { IconButton } from '@mui/material';
import { ButtonAnimate } from '../animate';

const MIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ children, ...other }, ref) => (
    <ButtonAnimate>
      <IconButton ref={ref} {...other}>
        {children}
      </IconButton>
    </ButtonAnimate>
  )
);

MIconButton.displayName = 'MIconButton';

export default MIconButton;
